import { motion, AnimatePresence } from "framer-motion";
import Loader from "../components/Loader";

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  variant?: "primary" | "danger";
  zIndex?: number;
}

const ConfirmModal = ({
  isOpen,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
  loading = false,
  variant = "primary",
  zIndex = 50,
}: ConfirmModalProps) => {
  const confirmBtnClass =
    variant === "danger"
      ? "px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition"
      : "px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition";
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={`fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-[${zIndex}]`}
          style={{ zIndex }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="relative bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {loading && (
              <div className="absolute inset-0 flex items-center justify-center bg-white/70 rounded-2xl">
                <Loader />
              </div>
            )}

            <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
            <p className="text-gray-600 mt-2">{message}</p>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={onCancel}
                className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                disabled={loading}
              >
                {cancelText}
              </button>
              <button
                onClick={onConfirm}
                className={confirmBtnClass}
                disabled={loading}
              >
                {loading ? "Processing..." : confirmText}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmModal;
